export default "__VITE_ASSET__26e4c6ea__"